import { combineReducers } from '@reduxjs/toolkit';

import { projectsReducer } from './projects/reducers';
import { userReducer } from './users/reducers';

const rootStateReducersMap = {
  projects: projectsReducer,
  user: userReducer,
};

export const rootReducer = combineReducers(rootStateReducersMap);
